import GenericApi from "./GenericApi";




export const AdmAssetIntActOrgQrApi = {
  downloadBrandedPng: <T>(GenericApi:GenericApi<T>,orgId:number) : T => {
    return GenericApi.get("api/admin/bc/asset_interaction/organisation/" + orgId + "/asset_interaction/org_qr/qr/branded/png")
  },
  getQrPng: <T>(GenericApi:GenericApi<T>,orgId:number) : T => {
    return GenericApi.get("api/admin/bc/asset_interaction/organisation/" + orgId + "/asset_interaction/org_qr/qr/png")
  },
}
export const AdmSupportVideoCallRecordingApi = {
  streamRecording: <T>(GenericApi:GenericApi<T>,orgId:number,callId:number,recordingId:number) : T => {
    return GenericApi.get("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/calls/" + callId + "/recordings/" + recordingId + "/download")
  },
}
export const AdmSupportVideoCallReviewApi = {
  streamSnapshotImage: <T>(GenericApi:GenericApi<T>,orgId:number,callId:number,snapshotId:string) : T => {
    return GenericApi.get("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video/calls/" + callId + "/review/snapshots/" + snapshotId + "/image")
  },
}
export const AdmSupportVideoCallSyncApi = {
  streamFrameImage: <T>(GenericApi:GenericApi<T>,orgId:number,callId:number,frameId:string) : T => {
    return GenericApi.get("api/admin/bc/asset_interaction/organisation/" + orgId + "/support/video/calls/" + callId + "/sync/frames/" + frameId + "/image")
  },
}

export const PublicSupportVideoCallSyncApi = {
  enduserStreamFrameImage: <T>(GenericApi:GenericApi<T>,roomId:string,frameId:string) : T => {
    return GenericApi.get("public-api/support/videocalls/enduser/sync/" + roomId + "/frames/" + frameId + "/image")
  },
}
